import { render } from "./BulkScanSwitchButton.vue?vue&type=template&id=5bfe1966"
import script from "./BulkScanSwitchButton.vue?vue&type=script&lang=ts"
export * from "./BulkScanSwitchButton.vue?vue&type=script&lang=ts"
script.render = render

export default script